import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=434dfbd4&scoped=true"
import script from "./Forgot.vue?vue&type=script&lang=ts"
export * from "./Forgot.vue?vue&type=script&lang=ts"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=434dfbd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434dfbd4",
  null
  
)

export default component.exports